module.exports = __webpack_public_path__ + "static/img/cont45 (2).df9a121.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont45 (2).jpg
// module id = QKIM
// module chunks = 0